import React, { Component } from 'react';
import TestPage from '../../test';
import TransactionList from './transaction_list';
import { Tag } from 'antd';
import { overrideHeaderBack } from '../../lib/util';


const queryString = require('query-string');

class DatatypeDataList extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      datatype_id:null,//props.match.params.datatype_id,
      comp_key:`${Math.random()}`,
      filter_data:{}
    };



  };
  
  render() {
    const{datatype_id}=this.state;
    return (
      <div> 
        {datatype_id&&
        <TransactionList 
        key={this.state.comp_key}

        query_params={{
          ...this.state.filter_data,
          datatype:datatype_id
        }
        }
        />}
      </div>
    );
  }

  componentWillReceiveProps (nextProps) {
    var olddatatype_id = this.props.match.params.datatype_id;
    var newdatatype_id = nextProps.match.params.datatype_id;
    if(olddatatype_id!==newdatatype_id || (
      this.props.location&&(this.props.location.search!==nextProps.location.search)
    )){
      console.log("param changes",newdatatype_id);
      const parsed = queryString.parse(nextProps.location.search);

      this.setState({
        datatype_id:newdatatype_id,
        filter_data:parsed,
        comp_key:`${newdatatype_id}`
      })
    }
  }
  

  updatedatatypeName=(name)=>{
    // typeof this.props.onChangeTag==='function' && this.props.onChangeTag({tagList:[
    //   <Tag>datatype</Tag>,
    //   name&&
    //   <Tag>{name}</Tag>
    // ]})
  }
  componentDidMount(){
    overrideHeaderBack('back')

    if(this.props.location.search){
      const parsed = queryString.parse(this.props.location.search);
      console.log("parsed filter data",parsed)
      this.setState({
        filter_data:parsed,
        comp_key:`${this.props.match.params.datatype_id}`,
        datatype_id:this.props.match.params.datatype_id,
      });


    }else{
      this.setState({
        comp_key:`${this.props.match.params.datatype_id}`,
        datatype_id:this.props.match.params.datatype_id,
      });
    }
  }
  componentWillUnmount(){
    overrideHeaderBack(null)

  }

  // componentDidUpdate(prevProps){
  //   if(prevProps.match.params!==this.props.match.params){
  //     console.log("calling changes")
  //     this.setState({
  //       datatype_id:prevProps.match.params.datatype_id
  //     })
  //   }
  // }

  
}

export default DatatypeDataList;
